module.exports = __webpack_public_path__ + "img/favorites.92132f11.svg";